{"schemaVersion":1,"release":{"version":"1.1.19","build":181,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.19-181.dmg","sha256":"4776d6b7971767b83c07fbcf4f362858138997fe0b8df244d79dca9d67026db6","size":287001241}}
